import React, { useEffect } from 'react';
import { Box, IconButton, IconChevronLeft24, ResponsiveSection } from '@stitch-fix/mode-react';
import { useRouter } from 'next/router';
import { EmailPasswordForm } from './EmailPasswordForm';
import { OneTimePasswordForm } from './OneTimePasswordForm';
import { SignInMachineContext } from '../../machines/sign-in/SignInMachineContext';
import usePasskeySignIn from './usePasskeys';
import type { ExecuteRecaptcha } from './RecaptchaV3Controller';
interface SignInProps {
  executeRecaptcha?: ExecuteRecaptcha;
}
export const SignIn = ({
  executeRecaptcha
}: SignInProps) => {
  const [state, send] = SignInMachineContext.useActor();
  const router = useRouter();
  useEffect(() => {
    if (router.query.error === 'link_expired' || router.query.error === 'account_inactive') {
      send({
        type: 'DISPLAY_LOGIN_ERROR_BANNER',
        error: router.query.error
      });
    }
  }, [send, router.query.error]);
  usePasskeySignIn();
  return <>
      {state.context.isDirectSignupClient && <Box mt={1} ml={1}>
          <IconButton aria-label="Back" onClick={() => window.history.back()} data-testid="back">
            <IconChevronLeft24 />
          </IconButton>
        </Box>}
      <ResponsiveSection gutter={{
      sm: 'standard',
      md: 'none'
    }} maxWidth={{
      sm: '100%',
      md: '400px'
    }} minHeight="40vh" my={2}>
        {state.matches('emailPasswordSignIn') && <EmailPasswordForm executeRecaptcha={executeRecaptcha} />}
        {state.matches('passwordlessSignIn') && <OneTimePasswordForm />}
      </ResponsiveSection>
    </>;
};